webpackJsonp([8],{

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventDetails_vue__ = __webpack_require__(1099);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d4a594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eventDetails_vue__ = __webpack_require__(1156);
function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d4a594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eventDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,DQoNCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDMyIDMyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGcgaWQ9ImNhbGVuZGFyXzFfIj4NCgkJPHBhdGggc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIGQ9Ik0yOS4zMzQsM0gyNVYxYzAtMC41NTMtMC40NDctMS0xLTFzLTEsMC40NDctMSwxdjJoLTZWMWMwLTAuNTUzLTAuNDQ4LTEtMS0xcy0xLDAuNDQ3LTEsMXYySDlWMQ0KCQkJYzAtMC41NTMtMC40NDgtMS0xLTFTNywwLjQ0Nyw3LDF2MkgyLjY2N0MxLjE5NCwzLDAsNC4xOTMsMCw1LjY2NnYyMy42NjdDMCwzMC44MDYsMS4xOTQsMzIsMi42NjcsMzJoMjYuNjY3DQoJCQlDMzAuODA3LDMyLDMyLDMwLjgwNiwzMiwyOS4zMzNWNS42NjZDMzIsNC4xOTMsMzAuODA3LDMsMjkuMzM0LDN6IE0zMCwyOS4zMzNDMzAsMjkuNzAxLDI5LjcwMSwzMCwyOS4zMzQsMzBIMi42NjcNCgkJCUMyLjI5OSwzMCwyLDI5LjcwMSwyLDI5LjMzM1Y1LjY2NkMyLDUuMjk5LDIuMjk5LDUsMi42NjcsNUg3djJjMCwwLjU1MywwLjQ0OCwxLDEsMXMxLTAuNDQ3LDEtMVY1aDZ2MmMwLDAuNTUzLDAuNDQ4LDEsMSwxDQoJCQlzMS0wLjQ0NywxLTFWNWg2djJjMCwwLjU1MywwLjQ0NywxLDEsMXMxLTAuNDQ3LDEtMVY1aDQuMzM0QzI5LjcwMSw1LDMwLDUuMjk5LDMwLDUuNjY2VjI5LjMzM3oiLz4NCgkJPHJlY3QgeD0iNyIgeT0iMTIiIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjciIHk9IjE3IiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSI3IiB5PSIyMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgkJPHJlY3QgeD0iMTQiIHk9IjIyIiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSIxNCIgeT0iMTciIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjE0IiB5PSIxMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgkJPHJlY3QgeD0iMjEiIHk9IjIyIiBzdHlsZT0iZmlsbDojZmZmZmZmOyIgd2lkdGg9IjQiIGhlaWdodD0iMyIvPg0KCQk8cmVjdCB4PSIyMSIgeT0iMTciIHN0eWxlPSJmaWxsOiNmZmZmZmY7IiB3aWR0aD0iNCIgaGVpZ2h0PSIzIi8+DQoJCTxyZWN0IHg9IjIxIiB5PSIxMiIgc3R5bGU9ImZpbGw6I2ZmZmZmZjsiIHdpZHRoPSI0IiBoZWlnaHQ9IjMiLz4NCgk8L2c+DQo8L2c+DQoNCjwvc3ZnPg0K"

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjaGV2cm9uLWxlZnQiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1jaGV2cm9uLWxlZnQgZmEtdy0xMCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj4KCTxwYXRoIGZpbGw9IiNlZDU5NjUiIGQ9Ik0zNC41MiAyMzkuMDNMMjI4Ljg3IDQ0LjY5YzkuMzctOS4zNyAyNC41Ny05LjM3IDMzLjk0IDBsMjIuNjcgMjIuNjdjOS4zNiA5LjM2IDkuMzcgMjQuNTIuMDQgMzMuOUwxMzEuNDkgMjU2bDE1NC4wMiAxNTQuNzVjOS4zNCA5LjM4IDkuMzIgMjQuNTQtLjA0IDMzLjlsLTIyLjY3IDIyLjY3Yy05LjM3IDkuMzctMjQuNTcgOS4zNy0zMy45NCAwTDM0LjUyIDI3Mi45N2MtOS4zNy05LjM3LTkuMzctMjQuNTcgMC0zMy45NHoiPgoJPC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__main__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"]
  },
  data: function data() {
    return {
      stop_sale: true,
      moment: __WEBPACK_IMPORTED_MODULE_6_moment___default.a,
      dateCardSlider: {
        arrows: true,
        slidesToShow: 20,
        // centerMode: true,
        // centerPadding: "3.5%",
        timingsData: "",
        slidesToScroll: 1,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 7000,
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: true,
            dots: false,
            // centerMode: false,
            slidesToShow: 5,
            // autoplaySpeed: 7000,
            // autoplay: true,
            infinite: false,
            slidesToScroll: 1
          }
        }]
      },
      selected_schedule_id: 0,
      url: __WEBPACK_IMPORTED_MODULE_5__helper_constant_js__["EVENT_URL"],
      eventDetails: [],
      eventSchedule: [],
      eventSeatType: [],
      eventTimings: [],
      eventVideos: [],
      selectedDate: "",
      eventSeatName: null,
      showDateTime: false,
      base_url: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])(["getSelectedSeats", "getSelectedSeatName"])),
  mounted: function mounted() {
    var eventID = this.$route.params.eventID;

    console.log(this.$route.params);
    this.getEventDetails(eventID);
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])(["addSelectedEvent", "addSelectedSchedule", "addSelectedSeats", "removeSelectedSeats", "addSelectedSeatName", "removeAllSelectedSeats"]), {
    openFancyBox: function openFancyBox() {
      $("a.btn-play").fancybox({
        zoomSpeedIn: 300,
        zoomSpeedOut: 300,
        overlayShow: false
      });
    },
    showDateTimeFn: function showDateTimeFn(type) {
      this.showDateTime = !this.showDateTime;
      setTimeout(function () {
        var elmnt = document.getElementById("showtimes-section");
        elmnt.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest"
        });
      }, 0);
    },
    getEventDetails: function getEventDetails(id) {
      var _this = this;

      this.showLoading();
      this.$cookies.set("retry_type", "event", "1d");
      this.$cookies.set("retry_id", id, "1d");
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/v1/event/details/" + id, "POST", null, null, this.url).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          _this.hideLoading();
          _this.base_url = res.data.base_url;
          _this.eventDetails = res.data.data;
          _this.stop_sale = _this.eventDetails.stop_sale == 1 ? true : false;
          console.log("object :>> ", _this.eventDetails.stop_sale, _this.stop_sale);
          console.log(_this.eventDetails.country_id);
          var country = {};
          if (_this.eventDetails.country_id == 175) {
            country.CountryID = 175;
            country.CountryISOCode = "974";
            country.CountryName = "Qatar";
            country.Flag = "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c77d4dc4e13c.jpg";
            country.ISOCode = "qa";
          } else if (_this.eventDetails.country_id == 113) {
            country.CountryID = 113;
            country.CountryISOCode = "973";
            country.CountryName = "Bahrain";
            country.Flag = "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b50ad.png";
            country.ISOCode = "bh";
          } else if (_this.eventDetails.country_id == 112) {
            country.CountryID = 112;
            country.CountryISOCode = "971";
            country.CountryName = "UAE";
            country.Flag = "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b51ad.png";
            country.ISOCode = "ae";
          }
          __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["CountryService"].saveCountry(country);
          __WEBPACK_IMPORTED_MODULE_8__main__["EventBus"].$emit("selectedCountry", country.CountryName);
          // CountryID: "175";
          // CountryISOCode: "974";
          // CountryName: "Qatar";
          // Flag: "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c77d4dc4e13c.jpg";
          // ISOCode: "qa";
          _this.eventDetails.e_videos.map(function (data) {
            if (data.e_video != null && data.e_video != "") {
              _this.eventVideos.push({
                thumbnail: "https://img.youtube.com/vi/" + data.e_video + "/0.jpg",
                url: "https://www.youtube.com/watch?v=" + data.e_video
              });
            }
          });
          console.log("Schedule Data>>>", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.venue[0].auditorium[0].schedule));
          _this.addSelectedEvent(res.data.data);
          _this.getEventSchedule(res.data.data.venue[0].auditorium[0].schedule);
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getEventSchedule: function getEventSchedule(data) {
      this.eventSchedule = data.filter(function (value, index, self) {
        return index === self.findIndex(function (t) {
          return __WEBPACK_IMPORTED_MODULE_6_moment___default()(t.es_date).format("YYYY-MM-DD") === __WEBPACK_IMPORTED_MODULE_6_moment___default()(value.es_date).format("YYYY-MM-DD");
        });
      });
      this.getEventTimings(this.eventSchedule[0].es_date, this.eventSchedule[0].event_schedule_id);
    },
    getEventTimings: function getEventTimings(date, id) {
      this.showLoading();
      var schedule = this.eventDetails.venue[0].auditorium[0].schedule;
      this.eventTimings = schedule.filter(function (data, index) {
        return __WEBPACK_IMPORTED_MODULE_6_moment___default()(data.es_date).format("YYYY-MM-DD") == __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format("YYYY-MM-DD");
      });
      this.selectedDate = id;
      this.hideLoading();
    },
    bookNowEvent: function bookNowEvent() {
      var _this2 = this;

      if (!this.selected_schedule_id) {
        this.$toasted.show("Please Select Timings");
        setTimeout(function () {
          _this2.$toasted.clear();
        }, 5000);
      } else {
        if (this.eventDetails.venue[0].auditorium[0].booking_type.toLowerCase() == "open") {
          if (this.eventDetails.additional_information != null && this.eventDetails.additional_information != "null") {
            this.showLoading();
            this.$refs["eventAdditionalModal"].show();
            this.hideLoading();
          } else {
            this.showSeatTypeModal();
            // this.selected_schedule_id = 0;
          }
        } else {
          this.$router.push({
            path: "/event-seat-layout/" + this.selected_schedule_id
          });
        }
      }
    },
    showAdditionalModal: function showAdditionalModal(id, data, type) {
      this.timingsData = data;
      this.selected_schedule_id = id;
      if (type == "single") {
        this.bookNowEvent();
      }
    },
    showSeatTypeModal: function showSeatTypeModal() {
      var _this3 = this;

      // this.selected_schedule_id = id;
      this.hideAdditionalModal();
      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/v1/event/getseattype/" + this.selected_schedule_id, "POST", null, null, this.url).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          _this3.eventSeatType = res.data.data;
          _this3.addSelectedSchedule(_this3.timingsData);
          _this3.$refs["eventSeatTypeModal"].show();
          // this.selected_schedule_id = 0;
          _this3.hideLoading();
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    countSeatType: function countSeatType(action, seatName, seatType) {
      if (this.checkSeatName(seatName)) {
        if (action == "add") {
          if (seatType.no_of_seat == undefined || seatType.no_of_seat <= 5) {
            this.$set(seatType, "no_of_seat", seatType["no_of_seat"] + 1 || 1);
            this.addSelectedSeats(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, seatType));
          }
        } else {
          if (seatType.no_of_seat > 0) {
            this.$set(seatType, "no_of_seat", seatType["no_of_seat"] - 1);
            this.removeSelectedSeats(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, seatType));
          }
        }
      }
      if (this.getSelectedSeats.length == 0) {
        // this.checkSeatName(seatName);
        var data = { seatname: seatName.aa_name };

        this.addSelectedSeatName({ data: data });
      }
    },
    checkSeatName: function checkSeatName(seatName) {
      var _this4 = this;

      return true;
      var data = { seatname: seatName.aa_name };

      if (this.getSelectedSeatName.length == 0 || this.getSelectedSeats.length == 0 || seatName.aa_name == this.getSelectedSeatName[0].data.seatname) {
        this.addSelectedSeatName({ data: data });
        return true;
      } else {
        this.$toasted.show("You can choose only one category");
        setTimeout(function () {
          _this4.$toasted.clear();
        }, 5000);
        return false;
      }
    },
    hideSeatTypeModal: function hideSeatTypeModal() {
      this.$refs["eventSeatTypeModal"].hide();
      this.removeAllSelectedSeats([]);
      this.eventSeatName = null;
    },
    hideAdditionalModal: function hideAdditionalModal() {
      this.$refs["eventAdditionalModal"].hide();
    },
    routePaymentPage: function routePaymentPage() {
      var _this5 = this;

      this.showLoading();
      console.log("this.getSelectedSeats.length11111", this.getSelectedSeats.length);
      console.log("first", this.getSelectedSeats);
      if (this.getSelectedSeats.length == 0) {
        this.$toasted.show("Please Select Seats");
        setTimeout(function () {
          _this5.$toasted.clear();
        }, 5000);
        this.hideLoading();
      } else {
        var eventID = this.$route.params.eventID;

        var country = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["CountryService"].getCountry();
        var data1 = {
          seat_details: this.getSelectedSeats,
          CountryID: country.CountryID
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/v1/event/eventreserve/" + this.selected_schedule_id, "POST", null, data1, this.url, false).then(function (response) {
          var error = response.error,
              res = response.res;

          _this5.hideLoading();
          if (error || res.error) {
            console.log("Response Error ");
            _this5.$toasted.show(res.error.message);
            setTimeout(function () {
              _this5.$toasted.clear();
            }, 5000);
          } else {
            _this5.$router.push({
              path: "/payment-summary/" + res.data.data.event_reserve_id
            });
            _this5.hideLoading();
          }
        }).catch(function (error) {
          _this5.hideLoading();
          // console.log("Error", error);
        });
        // this.$router.push({
        //   path: "/payment-summary",
        //   params: {
        //     props: { event_reserve_id: this.getSelectedSeats },
        //   },
        // });
      }
      // this.hideLoading();
    }
  })
});

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1039)("02058756", content, true, {});

/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1038)(true);
// imports


// module
exports.push([module.i, ".date-time-cursor{color:#fff}.event-date-slider .slick-prev{left:-1.5%}.event-date-slider .slick-next{right:-1.5%}.slick-disabled{z-index:-1!important}.event-date-slider .slick-next,.event-date-slider .slick-prev{width:30px;height:30px}@media (min-width:950px){.event-date-slider{width:98%;margin:auto}.event-time-flex{width:98%}.event-details-header .event-banner-img{height:488px!important}}@media (max-width:950px){.event-date-slider{width:88%;margin:auto}.event-time-flex{width:82%}.event-date-slider .slick-prev{left:-8%}.event-date-slider .slick-next{right:-8%}}@media (max-width:425px){.event-details-header{border-radius:0!important}.event-date-slider{width:95%;margin:auto}.event-time-flex{width:95%}.event-date-slider .slick-prev{left:-5%}.event-date-slider .slick-next{right:-5%}.event-date-slider .slick-next,.event-date-slider .slick-prev{width:25px;height:25px}}.read-more span{background:transparent!important;color:#fff!important}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/eventDetails.vue"],"names":[],"mappings":"AACA,kBAGE,UAAY,CACb,AACD,+BACE,UAAY,CACb,AACD,+BACE,WAAa,CACd,AACD,gBACE,oBAAuB,CAExB,AACD,8DAEE,WAAY,AACZ,WAAa,CACd,AACD,yBACA,mBACI,UAAW,AACX,WAAa,CAChB,AACD,iBACI,SAAW,CACd,AACD,wCACI,sBAAyB,CAC5B,CACA,AACD,yBACA,mBACI,UAAW,AACX,WAAa,CAChB,AACD,iBACI,SAAW,CACd,AACD,+BACI,QAAU,CACb,AACD,+BACI,SAAW,CACd,CACA,AACD,yBACA,sBACI,yBAA8B,CACjC,AACD,mBACI,UAAW,AACX,WAAa,CAChB,AACD,iBACI,SAAW,CACd,AACD,+BACI,QAAU,CACb,AACD,+BACI,SAAW,CACd,AACD,8DAEI,WAAY,AACZ,WAAa,CAChB,CACA,AACD,gBACE,iCAAmC,AACnC,oBAAwB,CACzB","file":"eventDetails.vue","sourcesContent":["\n.date-time-cursor {\n  /* cursor: pointer; */\n  /* text-decoration: underline; */\n  color: #fff;\n}\n.event-date-slider .slick-prev {\n  left: -1.5%;\n}\n.event-date-slider .slick-next {\n  right: -1.5%;\n}\n.slick-disabled {\n  z-index: -1 !important;\n  /* cursor: not-allowed !important; */\n}\n.event-date-slider .slick-prev,\n.event-date-slider .slick-next {\n  width: 30px;\n  height: 30px;\n}\n@media (min-width: 950px) {\n.event-date-slider {\n    width: 98%;\n    margin: auto;\n}\n.event-time-flex {\n    width: 98%;\n}\n.event-details-header .event-banner-img {\n    height: 488px !important;\n}\n}\n@media (max-width: 950px) {\n.event-date-slider {\n    width: 88%;\n    margin: auto;\n}\n.event-time-flex {\n    width: 82%;\n}\n.event-date-slider .slick-prev {\n    left: -8%;\n}\n.event-date-slider .slick-next {\n    right: -8%;\n}\n}\n@media (max-width: 425px) {\n.event-details-header {\n    border-radius: 0px !important;\n}\n.event-date-slider {\n    width: 95%;\n    margin: auto;\n}\n.event-time-flex {\n    width: 95%;\n}\n.event-date-slider .slick-prev {\n    left: -5%;\n}\n.event-date-slider .slick-next {\n    right: -5%;\n}\n.event-date-slider .slick-prev,\n  .event-date-slider .slick-next {\n    width: 25px;\n    height: 25px;\n}\n}\n.read-more span {\n  background: transparent !important;\n  color: white !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"eventAdditionalModal",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"eventAdditionalModal","hide-header":"","hide-footer":"","size":"md"}},[_c('h4',{staticClass:"text-center"},[_vm._v("Note")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"seat-name-card my-3"},[_c('div',[_c('div',{staticClass:"mb-2 seat-type-card"},[_c('div',[_c('p',[_vm._v("\n                "+_vm._s(_vm.eventDetails.additional_information)+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"seat-type-buttons"},[_c('button',{staticClass:"btn btn-cancel",on:{"click":function($event){return _vm.hideAdditionalModal()}}},[_vm._v("\n          CANCEL\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-pink",on:{"click":_vm.showSeatTypeModal}},[_vm._v("OK")])])])]),_vm._v(" "),_c('b-modal',{ref:"eventSeatTypeModal",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"eventSeatTypeModal","hide-header":"","hide-footer":"","size":"md"}},[_c('div',[_c('h5',{staticClass:"text-pink text-center mb-3"},[_vm._v("Select Category")]),_vm._v(" "),_vm._l((this.eventSeatType),function(seatName,seatNameindex){return _c('div',{key:seatNameindex,staticClass:"seat-name-card"},_vm._l((seatName.seat_type),function(seatType,seatTypeIndex){return _c('div',{key:seatTypeIndex},[_c('div',{staticClass:"mb-2 seat-type-card"},[_c('div',[_c('p',[_vm._v("\n                "+_vm._s(seatType.st_name)+" -\n                "+_vm._s(seatType.price)+"\n                "+_vm._s(seatType.currency)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"grid-counter"},[_c('span',{on:{"click":function($event){return _vm.countSeatType('minus', seatName, seatType)}}},[_vm._v("-")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("\n                  "+_vm._s(seatType.no_of_seat || 0)+"\n                ")])]),_vm._v(" "),_c('span',{staticClass:"plus-icon",on:{"click":function($event){return _vm.countSeatType('add', seatName, seatType)}}},[_vm._v("+")])])])])}),0)}),_vm._v(" "),_c('div',{staticClass:"seat-type-buttons mt-2"},[_c('button',{staticClass:"btn btn-cancel",on:{"click":function($event){return _vm.hideSeatTypeModal()}}},[_vm._v("\n          CANCEL\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-pink",on:{"click":function($event){return _vm.routePaymentPage()}}},[_vm._v("BOOK")])])],2)]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper_mob event-details-page pb-5"},[_c('div',{staticClass:"go-back"},[_c('a',{staticClass:"font-weight-bold",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go back\n      ")])]),_vm._v(" "),_c('div',{staticClass:"container-fluid event-detail-contain-mobile"},[_c('div',{staticClass:"row event-details-header justify-content-center"},[_c('div',{staticClass:"col-md-3 px-0 d-lg-block d-none"},[_c('img',{staticClass:"w-100 h-100 event-banner-img",attrs:{"src":_vm.base_url + _vm.eventDetails.e_image}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2 px-0 d-block d-lg-none"},_vm._l((this.eventDetails.e_banners),function(data,index){return _c('div',{key:index},[_c('img',{staticClass:"w-100 h-100 event-banner-img",attrs:{"src":_vm.base_url + data.e_banner}})])}),0),_vm._v(" "),_c('div',{staticClass:"col-lg-9 mt-2 col-12 mt-lg-0"},[_c('div',[_c('h3',{staticClass:"\n                text-pink\n                events-movie-heading\n                mt-lg-3\n                mb-0\n                text-mobile-head\n              "},[_vm._v("\n              "+_vm._s(_vm.eventDetails.e_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"event-genre d-none d-md-flex"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.eventDetails.rating))])]),_vm._v(" "),_vm._l((_vm.eventDetails.e_genre),function(data,index){return _c('div',{key:index},[(data.e_genre !== (null || ''))?_c('span',[_vm._v("\n                  "+_vm._s(data.e_genre)+"\n                ")]):_vm._e()])})],2),_vm._v(" "),_c('read-more',{staticClass:"read-more mt-1 mt-lg-2",attrs:{"more-str":"read more ","text":_vm.eventDetails.e_s_description.toString(),"link":"#","less-str":"read less","max-chars":220}}),_vm._v(" "),(_vm.eventDetails.es_date == _vm.eventDetails.ee_date)?_c('div',{staticClass:"mt-lg-3 mt-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-6"},[_c('div',{staticClass:"small"},[_vm._v("Event Date")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1079),"height":"16px","width":"16px","alt":""}}),_vm._v("\n                    "+_vm._s(_vm.moment(_vm.eventDetails.ee_date).format("MMM D / YYYY"))+"\n                  ")])]),_vm._v(" "),(_vm.eventSchedule.length == 1)?_c('div',{staticClass:"col-xl-3 col-6"},[_c('div',{staticClass:"small"},[_vm._v("Event Timing")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1079),"height":"16px","width":"16px","alt":""}}),_vm._v("\n                    "+_vm._s(_vm.moment(_vm.eventTimings[0].es_time, "h:mm a").format(
                        "h:mm a"
                      ))+"\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"small"},[_vm._v("Location")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.eventDetails.venue[0].ev_name))]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('a',{staticClass:"direction-color",attrs:{"target":"_blank","href":("http://www.google.com/maps/place/+" + (_vm.eventDetails.venue[0].ev_lat) + "," + (_vm.eventDetails.venue[0].ev_long))}},[_vm._v("Click Here")])])])]),_vm._v(" "),(!_vm.stop_sale)?_c('button',{staticClass:"btn btn-pink mt-2 mobile-width-btn",on:{"click":function($event){return _vm.showAdditionalModal(
                    _vm.eventTimings[0].event_schedule_id,
                    _vm.eventTimings[0],
                    'single'
                  )}}},[_vm._v("\n                Book Now\n              ")]):_vm._e()]):_c('div',{staticClass:"mt-lg-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-6"},[_c('div',{staticClass:"small"},[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1079),"height":"16px","width":"16px","alt":""}}),_vm._v("\n                    "+_vm._s(_vm.moment(_vm.eventDetails.es_date).format("MMM. D, YYYY"))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-6"},[_c('div',{staticClass:"small"},[_vm._v("End Date")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"mr-1",attrs:{"src":__webpack_require__(1079),"height":"16px","width":"16px","alt":""}}),_vm._v("\n                    "+_vm._s(_vm.moment(_vm.eventDetails.ee_date).format("MMM. D, YYYY"))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"small"},[_vm._v("Location")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.eventDetails.venue[0].ev_name))]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('a',{staticClass:"direction-color",attrs:{"target":"_blank","href":("http://www.google.com/maps/place/+" + (_vm.eventDetails.venue[0].ev_lat) + "," + (_vm.eventDetails.venue[0].ev_long))}},[_vm._v("Click Here")])])])]),_vm._v(" "),(!_vm.showDateTime)?_c('button',{staticClass:"btn btn-pink mt-2",on:{"click":_vm.showDateTimeFn}},[_vm._v("\n                Book Now\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[(this.eventVideos.length > 0)?_c('div',{staticClass:"mt-2 mb-2"},[_c('div',{class:['small d-flex']},[_vm._v("Video")]),_vm._v(" "),_c('div',{staticClass:"d-flex position-relative",staticStyle:{"min-height":"118px"}},_vm._l((this.eventVideos),function(trailer,youtubeKey){return _c('div',{key:youtubeKey,staticClass:"trailer-box",style:({
                      'background-image': 'url(' + trailer.thumbnail + ')',
                    })},[_c('a',{staticClass:"btn-play",attrs:{"href":trailer.url,"data-fancybox":""}})])}),0)]):_vm._e()])],1)])]),_vm._v(" "),(
          (_vm.showDateTime && _vm.eventDetails.es_date != _vm.eventDetails.ee_date) ||
          (_vm.eventDetails.es_date == _vm.eventDetails.ee_date &&
            _vm.eventSchedule.length > 1)
        )?_c('div',{staticClass:"row showtimes-section mt-4 mb-3",attrs:{"id":"showtimes-section"}},[_c('div',{staticClass:"col-lg-12 px-0"},[_c('h5',[_vm._v("Event Dates")]),_vm._v(" "),_c('div',{staticClass:"custom-shadow mt-2"},[_c('div',[(_vm.eventSchedule.length > 0)?_c('Slick',{ref:"eventDateFlex",staticClass:"event-date-slider",attrs:{"options":_vm.dateCardSlider}},_vm._l((_vm.eventSchedule),function(data,index){return _c('div',{key:index,on:{"click":function($event){return _vm.getEventTimings(data.es_date, data.event_schedule_id)}}},[_c('div',{staticClass:"event-date-card",class:_vm.selectedDate == data.event_schedule_id
                        ? 'date-card-active'
                        : ''},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.moment(data.es_date).format("D")))]),_vm._v(" "),_c('span',{staticClass:"day"},[_vm._v(_vm._s(_vm.moment(data.es_date).format("ddd")))])])])}),0):_vm._e()],1)])]),_vm._v(" "),(!_vm.stop_sale)?_c('div',{staticClass:"col-lg-12 mt-3 px-0"},[_c('div',{staticClass:"custom-shadow"},[_c('h6',{staticClass:"mx-3"},[_vm._v("Select Timings")]),_vm._v(" "),_c('div',{staticClass:"event-time-flex mt-3"},_vm._l((_vm.eventTimings),function(data,index){return _c('div',{key:index,staticClass:"event-time-card",class:_vm.selected_schedule_id == data.event_schedule_id
                    ? 'date-card-active'
                    : '',on:{"click":function($event){return _vm.showAdditionalModal(data.event_schedule_id, data)}}},[_vm._v("\n                "+_vm._s(_vm.moment(data.schedule_time, "h:mm a").format("h:mm a"))+"\n              ")])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-pink mt-3 mx-3",on:{"click":_vm.bookNowEvent}},[_vm._v("\n              Book Now\n            ")])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"\n          row\n          event-details-accordion\n          custom-shadow\n          mt-3\n          py-3\n          event-detail-content-mobile\n        "},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"accordion",attrs:{"role":"tablist"}},[_c('div',[_c('div',{attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-1",modifiers:{"accordion-1":true}}],staticClass:"\n                    d-flex\n                    text-capitalize\n                    btn_acc\n                    justify-content-between\n                    align-items-center\n                  ",attrs:{"block":"","variant":"info"}},[_vm._v("\n                  About Events\n                  "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1091)}})])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.eventDetails.e_description)}})])],1),_vm._v(" "),_c('div',{staticClass:"my-3"},[_c('div',{attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-2",modifiers:{"accordion-2":true}}],staticClass:"\n                    d-flex\n                    text-capitalize\n                    btn_acc\n                    justify-content-between\n                    align-items-center\n                  ",attrs:{"block":"","variant":"info"}},[_vm._v("\n                  Organizer Info\n                  "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1091)}})])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-2","accordion":"my-accordion","role":"tabpanel"}},_vm._l((_vm.eventDetails.organiser_details),function(data,index){return _c('div',[_c('h6',{staticClass:"font-weight-bold mb-0"},[_vm._v(_vm._s(data.od_name))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(data.od_sdescription)}}),_vm._v(" "),_c('div',[_c('p',[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v("\n                      "+_vm._s(data.od_email)+"\n                    ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(data.od_mobile))])])])}),0)],1),_vm._v(" "),_c('div',[_c('div',{attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-3",modifiers:{"accordion-3":true}}],staticClass:"\n                    d-flex\n                    text-capitalize\n                    btn_acc\n                    justify-content-between\n                    align-items-center\n                  ",attrs:{"block":"","variant":"info"}},[_vm._v("\n                  Terms And Condition\n                  "),_c('img',{staticClass:"acc_img",attrs:{"src":__webpack_require__(1091)}})])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-3","accordion":"my-accordion","role":"tabpanel"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.eventDetails.terms_condition)}})])],1)])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.9d967e0e3c340ddadb0d.js